// @core/api/endpoints/project/get_cumulative_flow.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CumulativeFlowResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Get cumulative flow diagram
 * Returns cumulative flow diagram data showing item counts per column over time. Helps identify bottlenecks and flow efficiency.
 */
export async function GetCumulativeFlow(
  project_id: string,
  options?: RequestOptions
): Promise<CumulativeFlowResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/cumulative-flow`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.get<CumulativeFlowResponse>(requestPath, { ...requestOptions });
}
